import { createContext, useContext, useState } from 'react'

export const AgentListFilterContext = createContext()
export default function useAgentListFilterContext() {
  return useContext(AgentListFilterContext)
}

export function AgentListFilterState(defaultFilter) {
  const [filter, setFilter] = useState()

  return {
    filter,
    setFilter
  }
}